module.exports = __webpack_public_path__ + "img/lyal_b3.1d8def0e.jpg";